import { getMainApi } from "@Shared/utils/ajax";
import { getSecureAccountsApi } from "@Shared/utils/ajax";
export const getNearApps = async (days, agentUsername, status) => {
  return getMainApi({
    days,
    agentUsername,
    status
  }, "/statistics/mortgage-renewal");
};
export const getNearFollowups = async (days, expired = false) => {
  const {
    followUps
  } = await getMainApi({
    days,
    expired
  }, "/statistics/follow-up");
  return followUps;
};
export const getNearBirthdays = async (days, agentUsername) => {
  const {
    birthdays
  } = await getMainApi({
    days,
    agentUsername
  }, "/statistics/birthday");
  return birthdays;
};
export const getNearAppsAsCSV = async (days, agentUsername) => {
  return getMainApi({
    days,
    agentUsername
  }, "/statistics/mortgage-renewal/download");
};
export const getNearFollowupsAsCSV = async (days, expired) => {
  return getMainApi({
    days,
    expired
  }, "/statistics/follow-up/download");
};
export const getNearBirthdaysAsCSV = async (days, agentUsername) => {
  return getMainApi({
    days,
    agentUsername
  }, "/statistics/birthday/download");
};
export const getCalendarEvents = async date => {
  return getSecureAccountsApi({}, `/calendar/event?date=${date}`);
};
export const getClientActivity = async (agentUsername, loadAll, pagination) => {
  const {
    offset = 0,
    limit = 20
  } = pagination || {};
  const params = {
    all: loadAll,
    offset,
    limit
  };
  if (agentUsername) params.agentUsername = agentUsername;
  return getSecureAccountsApi(params, "/client-activity");
};
export const getSubmissionHistoryByAgent = async (agentUsername, loadAll = false) => {
  const endpoint = `/statistics/lender-direct`;
  const params = {
    all: loadAll
  };
  if (agentUsername) params.agentUsername = agentUsername;
  return getMainApi(params, endpoint);
};
export const getClosesByMonth = async (month, agentUsername) => {
  const data = {
    month,
    agentUsername
  };
  return getMainApi(data, "/statistics/closes");
};
export const getAppsReceivedByYear = async agentUsername => {
  const data = {
    agentUsername
  };
  return getMainApi(data, "/statistics/yoysubmitted");
};
export const getApplicationsByUser = agentUsername => {
  const data = {
    agentUsername
  };
  return getMainApi(data, "/statistics/applications");
};
export const getBrokerImportReportAsCSV = async clientActivityId => {
  const data = {
    clientActivityId
  };
  return getMainApi(data, `/filogix/import/download`);
};